import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import Axios from '@/lib/axios-instance';

type APIPayload = {
    id: string;
};

type ResponseType = {
    data: any;
    meta: any;
};

export const deleteMember = async (payload: APIPayload) => {
    try {
        const response = await Axios.delete(`/users/members/${payload.id}`);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(
                `${error.response.data?.meta?.message || 'An error occurred'}`,
            );
        }
        throw new Error(error.message || 'Network Error');
    }
};

export const useDeleteMember = () => {
    const queryClient = useQueryClient();
    return useMutation<ResponseType, Error, APIPayload>({
        mutationFn: (payload: APIPayload) => deleteMember(payload),
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['get-all-members'] });
            console.log(data);
        },
        onError: (error) => {
            toast.error('Deleting Member Failed', { description: error.message });
        },
    });
};
